<template>
  <ToastRoot
    v-bind="{ ...props, ...useEmitAsProps(emits) }"
    :class="contentClass"
    @update:open="onOpenChange"
  >
    <slot />
  </ToastRoot>
</template>

<script setup>
import { computed } from 'vue'
import { ToastRoot, useEmitAsProps } from 'radix-vue'

/* eslint-disable vue/require-default-prop */
const props = defineProps({
  class: { type: String, required: false },
  variant: { type: String, required: false },
  onOpenChange: { type: Function, required: false, skipCheck: true },
  type: { type: String, required: false },
  open: { type: Boolean, required: false },
  duration: { type: Number, required: false },
  dismissable: { type: Boolean, default: true },
})

const emits = defineEmits([
  'close',
  'escapeKeyDown',
  'pause',
  'resume',
  'swipeStart',
  'swipeMove',
  'swipeCancel',
  'swipeEnd',
  'update:open',
])

const contentClass = computed(() => [
  'toast fade show animated',
  props.variant && props.variant !== 'default' && `align-items-center border-0 text-bg-${props.variant}`,
  props.class,
])
</script>
